export default "__VITE_ASSET__ChDynV0s__"